import { useState } from "react";
import axios from "axios";
import Heading from "./Heading";
import { smallSphere, stars } from "../assets";
import Section from "./Section";
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });

  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); // New state for loading spinner

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Enforce character limit on the message field
    if (name === "message" && value.length > 2000) return;

    setFormData({ ...formData, [name]: value });
  };

  const handleServiceSelect = (service) => {
    setFormData((prev) => ({
      ...prev,
      service: prev.service === service ? "" : service,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Start loading spinner

    try {
      const token = await window.grecaptcha.execute(
        "6LdP2KcqAAAAALIVF5tv-48L6P85fgm_y8CbmB12",
        {
          action: "submit",
        },
      );
      const response = await axios.post("/contact-form/submit_form.php", {
        ...formData,
        token,
      });
      setStatus(response.data.message);

      // Clear the status message and reset the form after 4 seconds
      setTimeout(() => {
        setFormData({
          name: "",
          email: "",
          phone: "",
          service: "",
          message: "",
        });
        setStatus("");
      }, 4000);
    } catch (error) {
      console.error(error);
      setStatus("Failed to submit the form. Please try again later.");

      // Clear the status message after 4 seconds even on error
      setTimeout(() => {
        setStatus("");
      }, 4000);
    } finally {
      setIsSubmitting(false); // Stop loading spinner
    }
  };

  return (
    <Section>
      <div className="container py-8 lg:mb-24" id="contact">
        <Heading
          className="!mb-5"
          title="CONTACT US"
          text="Whether you're looking to build a stunning website, develop a powerful mobile app, or harness the potential of AI solutions — we're here to bring your ideas to life. Reach out and let's create something incredible together!"
          textclassName="!text-slate-200  mx-auto sm:text-sm !text-left !mt-8 !sm:mt-16 tagline leading-loose"
        />
        <div className="relative mb-[6.5rem] mt-10 hidden justify-center lg:flex">
          <img
            src={smallSphere}
            className="relative z-1 hidden lg:flex"
            width={255}
            height={255}
            alt="BafarLabs"
          />
          <div className="pointer-events-none absolute left-1/2 top-1/2 w-[60rem] -translate-x-1/2 -translate-y-1/2">
            <img
              src={stars}
              className="hidden w-full lg:flex"
              width={950}
              height={400}
              alt="Stars"
            />
          </div>
        </div>
        <div className="grid w-full grid-cols-1">
          <div className="mx-auto w-full space-y-6 rounded-2xl py-4 lg:w-[75%] lg:px-8">
            <ul className="grid grid-cols-1 gap-6 sm:grid-cols-3" role="list">
              <li
                role="listitem"
                className="mx-auto flex w-full flex-col items-center justify-center rounded-xl bg-neutral-950 hover:bg-neutral-800"
              >
                <a
                  href="mailto:&#105;&#110;&#102;&#111;&#64;&#98;&#97;&#102;&#97;&#114;&#108;&#97;&#98;&#115;&#46;&#99;&#111;&#109;"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-auto flex w-full flex-col items-center justify-center rounded-xl bg-neutral-950 p-3 hover:bg-neutral-800"
                >
                  <img
                    src="./mail.svg"
                    alt="Mail icon for contacting BafarLabs"
                    className="h-[50px] w-[50px]"
                    loading="lazy"
                  />
                  <p className="mt-4 sm:text-base">
                    &#105;&#110;&#102;&#111;&#64;&#98;&#97;&#102;&#97;&#114;&#108;&#97;&#98;&#115;&#46;&#99;&#111;&#109;
                  </p>
                </a>
              </li>
              <li
                role="listitem"
                className="mx-auto flex w-full items-center justify-center rounded-xl bg-neutral-950 hover:bg-neutral-800"
              >
                <a
                  href="tel:+919539642647"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-auto flex w-full flex-col items-center justify-center rounded-xl bg-neutral-950 p-3 hover:bg-neutral-800"
                >
                  <img
                    src="./phone.svg"
                    alt="Phone icon for contacting BafarLabs"
                    className="h-[50px] w-[50px]"
                    loading="lazy"
                  />
                  <p className="mt-4 sm:text-base">+91 95396 42647</p>
                </a>
              </li>
              <li
                role="listitem"
                className="mx-auto flex w-full flex-col items-center justify-center rounded-xl bg-neutral-950 hover:bg-neutral-800"
              >
                <a
                  href="https://maps.app.goo.gl/xFrrrDmf5vSr68mE8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-auto flex w-full flex-col items-center justify-center rounded-xl bg-neutral-950 p-3 hover:bg-neutral-800"
                >
                  <img
                    src="./location.svg"
                    alt="Location icon for BafarLabs offices"
                    className="h-[50px] w-[50px]"
                    loading="lazy"
                  />
                  <p className="mt-4 sm:text-base">
                    Kozhikode, India
                    <br />
                    Doha, Qatar
                  </p>
                </a>
              </li>
            </ul>
          </div>

          <form
            className="mx-auto w-full space-y-4 rounded-2xl bg-neutral-950 p-8 lg:w-[70%]"
            onSubmit={handleSubmit}
          >
            <h3 className="mb-8 text-center text-3xl font-extrabold text-white">
              Reach Out To Us
            </h3>

            <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
              <div className="grid grid-cols-1 gap-5">
                <>
                  <label
                    htmlFor="name"
                    className="mb-2 block text-sm font-semibold text-white"
                  >
                    Name
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      id="name"
                      placeholder="Name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full rounded-md bg-neutral-900 p-4 pl-12 text-sm text-slate-200 placeholder-gray-400 outline-none focus:bg-neutral-800"
                    />
                    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
                      <img
                        src="/user-solid.svg"
                        className="h-4 w-4"
                        alt="user"
                      />
                    </span>
                  </div>
                </>

                <>
                  <label
                    htmlFor="email"
                    className="mb-2 block text-sm font-semibold text-white"
                  >
                    Email
                  </label>
                  <div className="relative">
                    <input
                      type="email"
                      id="email"
                      placeholder="Email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full rounded-md bg-neutral-900 p-4 pl-12 text-sm text-slate-200 placeholder-gray-400 outline-none focus:bg-neutral-800"
                    />
                    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
                      <img
                        src="/envelope-solid.svg"
                        className="h-4 w-4"
                        alt="mail"
                      />
                    </span>
                  </div>
                </>

                <>
                  <label
                    htmlFor="phone"
                    className="mb-2 block text-sm font-semibold text-white"
                  >
                    Phone Number
                  </label>
                  <div className="relative">
                    <input
                      type="tel"
                      id="phone"
                      placeholder="Phone Number"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="w-full rounded-md bg-neutral-900 p-4 pl-12 text-sm text-slate-200 placeholder-gray-400 outline-none focus:bg-neutral-800"
                    />
                    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
                      <img
                        src="/phone-solid.svg"
                        className="h-4 w-4"
                        alt="phone"
                      />
                    </span>
                  </div>
                </>
              </div>

              <div className="">
                <label
                  htmlFor="message"
                  className="mb-2 block text-sm font-semibold text-white"
                >
                  Message
                </label>
                <textarea
                  placeholder="Message (2000 characters max)"
                  name="message"
                  id="message"
                  value={formData.message}
                  onChange={handleChange}
                  maxLength={2000}
                  rows={6}
                  required
                  className="min-h-[90%] w-full resize-none rounded-md bg-neutral-900 p-4 text-sm text-slate-200 placeholder-n-2 placeholder-opacity-50 outline-none focus:bg-neutral-800"
                />
              </div>
            </div>
            <label className="my-2 block text-center text-xl font-semibold text-white">
              Select Your Service
            </label>
            <div
              className="grid grid-cols-2 gap-4 md:grid-cols-3"
              id="servicebuttons"
            >
              {[
                "Web Apps",
                "Mobile Apps",
                "Ecommerce",
                "AI Solutions",
                "Software Solutions",
                "AI Calling Agent",
              ].map((service) => (
                <button
                  key={service}
                  type="button"
                  onClick={() => handleServiceSelect(service)}
                  className={`rounded-md p-5 text-base font-medium ${
                    formData.service === service
                      ? "bg-neutral-600 text-white"
                      : "bg-neutral-900 text-slate-200 hover:bg-neutral-500"
                  }`}
                >
                  {service}
                </button>
              ))}
            </div>

            {/* Message Field */}

            {/* Status Message */}
            {status && <p className="mt-2 text-center text-white">{status}</p>}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              className={`mx-auto mt-6 flex w-1/2 justify-center rounded-md p-4 text-base tracking-wide text-white ${
                isSubmitting
                  ? "bg-neutral-600"
                  : "bg-neutral-900 hover:bg-neutral-600"
              }`}
            >
              {isSubmitting ? (
                <div className="h-6 w-6 animate-spin rounded-full border-b-2 border-t-2 border-white"></div>
              ) : (
                "Submit"
              )}
            </button>
          </form>
        </div>
      </div>
    </Section>
  );
};

export default Contact;
